import { render, staticRenderFns } from "./MsgSettingModal.vue?vue&type=template&id=43dd7202&"
import script from "./MsgSettingModal.vue?vue&type=script&lang=js&"
export * from "./MsgSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports